import { MutationTree } from 'vuex';
import { State } from './state';

export function createMutations(): MutationTree<State> {
  return {};
}
